module.exports = __webpack_public_path__ + "img/banner-about.a3ae4cfb.png";